export default __webpack_public_path__ + "static/media/exclamation-mark.f3b9e980.svg";